import { useEffect, useState } from 'react';
import { CustonGraph } from '../../Components';
import { Container, ContainerGraph, LegendContainer, ContainerName, Variablesindicator, VariableLegend, VariableColor, ButtonsContainer, TimeSelector, StyledOption, ScaleText } from './styles';
import { NumberInput, Text } from '../styles';
import { useTranslation } from "react-i18next";

const CustonGraphContainer = ({id, Name, hasSP, data, max, min, ChangeTime, color, changeScale}) => {

    const { t } = useTranslation();

    function filterDataByTime(array) {
        return array.map(item => ({
            id: item.id,
            Loading: item.Loading,
            data: item.data.map(entry => {;
                entry.x = new Date(entry.x)
                return entry
            }),
        }));
    }
    useEffect(() => {
        setMaximo(max)
        setMinimo(min)
    },[max, min])

    const [maximo, setMaximo] = useState(max)
    const [minimo, setMinimo] = useState(min)

    return (
        <Container id={id} color={color}>
            <LegendContainer>
                <ContainerName>
                    {Name}
                </ContainerName>
                <Variablesindicator>
                    <VariableLegend>
                        <VariableColor $color={'#4361EE'}/>
                        {t("components.custom-graph.variable-caption.process-variable")}
                    </VariableLegend>

                    {hasSP?
                        <VariableLegend>
                            <VariableColor $color={'#3C9'}/>
                            {t("components.custom-graph.variable-caption.set-point")}
                        </VariableLegend>
                    :<></>}
                </Variablesindicator>
                
                <ScaleText>{t("components.custom-graph.scale-text")}:</ScaleText>

                <TimeSelector onChange={(e) => ChangeTime(e.target.value, color)}>
                    <StyledOption value={120}> 2 {t("components.custom-graph.time.hours")} </StyledOption>
                    <StyledOption value={360}> 6 {t("components.custom-graph.time.hours")} </StyledOption>
                    <StyledOption value={720}> 12 {t("components.custom-graph.time.hours")} </StyledOption>
                    <StyledOption value={1440}> 24 {t("components.custom-graph.time.hours")} </StyledOption>
                    <StyledOption value={10080}> 1 {t("components.custom-graph.time.weeks")} </StyledOption>
                    <StyledOption value={20160}> 2 {t("components.custom-graph.time.weeks")} </StyledOption>
                </TimeSelector>
                
                <ButtonsContainer>
                    <Text>Máx.</Text>
                    <NumberInput type='number' value={maximo} onChange={(e) => {
                        setMaximo(e.target.value)
                        if(changeScale){changeScale(null, e.target.value)}
                    }}></NumberInput>
                </ButtonsContainer>
                <ButtonsContainer>
                    <Text>Min.</Text>
                    <NumberInput type='number' value={minimo} onChange={(e) => {
                        setMinimo(e.target.value)
                        if(changeScale){changeScale(e.target.value, null)}
                    }}></NumberInput>
                </ButtonsContainer>


            </LegendContainer>
            <ContainerGraph>
                {data.length > 0 ?
                    <CustonGraph data={filterDataByTime(JSON.parse(JSON.stringify(data)))} SP={hasSP? true : false} max={maximo} min={minimo}/>
                :<></>}
            </ContainerGraph>
        </Container>
    );
}

export default CustonGraphContainer;